if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', class extends HTMLElement {
    static cartRequest;

    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.price = Number(this.dataset.price);
      this.available = this.dataset.available === 'true';
      this.requiresShipping = this.dataset.requiresShipping !== 'false';
      this.subtotal = Number(this.dataset.subtotal);
      this.unsubscribers = [];
      this.onChange = (event) => {
        if (this.dataset.mode !== 'product') return;
        if (event.target.name === 'quantity' && event.target.form?.id === this.dataset.formId) this.render();
        const picker = event.target.closest('variant-selects, variant-radios');
        if (picker?.dataset.section === this.dataset.sectionId) {
          this.available = false;
          this.render();
        }
      };
      document.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function') {
        if (this.dataset.mode === 'product') {
          this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            const variant = event.data.variant;
            this.price = Number(variant.price);
            this.available = variant.available;
            this.requiresShipping = variant.requires_shipping !== false;
            this.render();
          }));
          this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.render()));
        } else {
          this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart()));
        }
      }
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      this.unsubscribers.forEach((unsubscribe) => unsubscribe());
    }

    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency', currency: this.dataset.currency || 'EUR'
      }).format(cents / 100);
    }

    render() {
      let subtotal = this.subtotal;
      let quantity = 1;
      const isProduct = this.dataset.mode === 'product';
      if (isProduct) {
        const form = document.getElementById(this.dataset.formId);
        const input = form?.elements.namedItem('quantity');
        quantity = Math.max(1, Number(input?.value) || 1);
        subtotal = this.price * quantity;
        this.hidden = !this.requiresShipping;
      }
      const success = subtotal >= this.threshold && (!isProduct || this.available);
      let message;
      if (isProduct) {
        message = success
          ? (quantity > 1 ? this.dataset.quantitySuccess : this.dataset.productSuccess)
          : this.dataset.minimum.replace('[amount]', this.money(this.threshold));
      } else {
        message = success ? this.dataset.success
          : this.dataset.remaining.replace('[amount]', this.money(Math.max(0, this.threshold - subtotal)));
      }
      this.classList.toggle('fspbar--success', success);
      this.querySelector('.fspbar__text').textContent = message;
      const fill = this.querySelector('.fspbar__fill');
      if (fill) fill.style.width = Math.max(0, Math.min(100, subtotal / this.threshold * 100)) + '%';
    }

    async refreshCart() {
      const constructor = this.constructor;
      if (!constructor.cartRequest) {
        constructor.cartRequest = fetch(this.dataset.cartUrl, {credentials:'same-origin'})
          .then((response) => {
            if (!response.ok) throw new Error('Cart could not be loaded');
            return response.json();
          }).finally(() => { constructor.cartRequest = null; });
      }
      try {
        const cart = await constructor.cartRequest;
        if (!this.isConnected) return;
        this.subtotal = Number(cart.total_price || 0);
        this.render();
      } catch {
        // Keep the server-rendered cart state when the request fails.
      }
    }
  });
}
